import ScopeConstants from "constants/ScopeConstants"

export const ProjectSummaryManagerScope = {
    key: ScopeConstants.PROJECT_SUMMARY_MANAGER,
    selector: (state) => state.projectSummaryManagerReducer,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/Project/GetSumaaryAsManager",
}